export interface DelimiterChoice {
  value: string;
  i18nKey: string;
}

export const DELIMITER_CHOICES: readonly DelimiterChoice[] = [
  { value: ';',  i18nKey: 'delimiterNames.;' },
  { value: ',',  i18nKey: 'delimiterNames.,' },
  { value: '\t', i18nKey: 'delimiterNames.\t' },
  { value: '|',  i18nKey: 'delimiterNames.|' },
] as const;

const SUPPORTED = new Set(DELIMITER_CHOICES.map(c => c.value));

export const isSupportedDelimiter = (value: string): boolean => SUPPORTED.has(value);
